import { Component, Input, OnInit } from '@angular/core';
import * as jsonpath from 'jsonpath';

@Component({
  selector: 'app-display-json',
  templateUrl: './display-json.component.html',
  styleUrls: ['./display-json.component.scss']
})
export class DisplayJsonComponent<T> implements OnInit {

  @Input()
  data: T;
  @Input()
  jsonPath: string;
  jsonToDisplay: any;

  ngOnInit(): void {
    try {
      this.jsonToDisplay = jsonpath.value(this.data || {}, this.jsonPath || '$.*');
    } catch (error) {
      this.jsonToDisplay = {};
    }
  }

}
